import Document from "src/models/document";
import Response from "src/models/response";
import Result from "src/models/result";

import { store } from "../components/App";

import cfg from "./config";

class IndexClient {
  private static async getHeaders(): Promise<Headers> {
    const user = store.getState().session.user;

    return new Promise<Headers>((resolve, reject) => {
      const headerContent: any = {
        "Content-Type": "application/json"
      };

      if (!user) {
        resolve(new Headers(headerContent));
        return;
      }

      const tokenPromise = user.getIdToken();
      tokenPromise.then(
        (tok: string) => {
          headerContent.Authorization = "Bearer " + tok;
          resolve(new Headers(headerContent));
        },
        (r: any) => reject(r)
      );
    });
  }

  private readonly host: string;
  private readonly port: string;

  constructor() {
    this.host = cfg.Host;
    this.port = cfg.Port;

    this.query = this.query.bind(this);
  }

  public async query(
    queryExpression: string,
    offset: number
  ): Promise<Response> {
    try {
      const headers = await IndexClient.getHeaders();

      const response = await fetch(`https://${this.host}:${this.port}/search`, {
        body: JSON.stringify({
          expression: queryExpression,
          load_documents: true,
          offset,
          size: 10
        }),
        headers,
        method: "post"
      });

      const raw = await response.json();
      // tslint:disable:no-console
      console.log("Response: ", raw);

      const results = raw.results.map(
        (res: any) =>
          new Result(
            new Document(
              res.document.uri,
              res.document.source_id,
              res.document.data,
              res.document.type,
              res.document.indexed_at,
              res.document.date
            ),
            res.score
          )
      );
      return new Response(results, raw.count, raw.total, raw.facet_values);
    } catch (ex) {
      return new Response([], -1, -1, {});
    }
  }
}

export default IndexClient;



// WEBPACK FOOTER //
// ./src/sdk/client.ts